import { render, staticRenderFns } from "./GrossProfit.vue?vue&type=template&id=4833acc0&"
import script from "./GrossProfit.vue?vue&type=script&lang=js&"
export * from "./GrossProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports